import { cn } from "@/shared/lib/utils";

/**
 * The RxNorm code (RxCUI) a medicine was matched to, as a small tag — on every
 * medicine in the Medications tab and the Human Review Queue. "No RxCUI" when
 * no standard medicine was found for it.
 */
export function RxcuiTag({ rxcui, className }: { rxcui?: string | null; className?: string }) {
  return rxcui ? (
    <span
      title="RxNorm code (RxCUI) this medicine was matched to"
      data-testid="rxcui-tag"
      className={cn("inline-flex shrink-0 items-center rounded-md bg-[#EEF2F7] px-1.5 py-0.5 font-mono text-[10px] font-bold text-[#0A2947]", className)}
    >
      RxCUI {rxcui}
    </span>
  ) : (
    <span
      title="No RxNorm code was found for this medicine"
      data-testid="rxcui-tag"
      className={cn("inline-flex shrink-0 items-center rounded-md bg-[#F3F4F6] px-1.5 py-0.5 text-[10px] font-semibold text-[#9CA3AF]", className)}
    >
      No RxCUI
    </span>
  );
}
